import React, { Component } from "react";
import "./ProfilePage.css";
import NavBarLogout from "./components/navbarLogout";
import Footer from "./components/footer";
import Profile from "./components/profile";
import Welcome from "./components/welcome";
import Info from "./components/info";
import history from "./history";
const Cryptr = require("cryptr");
const cryptr = new Cryptr(process.env.REACT_APP_KEY);

class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: null,
      dob: null,
      email: null,
      address: null,
      gender: null,
      nationality: null
    };
  }
  componentDidMount() {
    let data = this.props.location.search;
    let buff = new Buffer(data, "base64");
    let text = buff.toString("ascii");
    const textDecrypted = cryptr.decrypt(text);
    const values = JSON.parse(textDecrypted);
    this.setState({
      name: values.name,
      dob: values.dob,
      email: values.email,
      address: values.address,
      gender: values.gender,
      nationality: values.nationality
    });
    history.replace("/crypto/profile");
  }

  render() {
    const { name, dob, email, address, gender, nationality } = this.state;
    return (
      <React.Fragment>
        <div className="Profile">
          <header className="Profile-header">
            <NavBarLogout />
          </header>
          <Welcome />
        </div>
        <div className="container">
          <div className="row clear">
            <div className="col">
              <Profile />
            </div>
            <div className="col">
              <Info
                name={name}
                dob={dob}
                email={email}
                address={address}
                gender={gender}
                nationality={nationality}
              />
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default ProfilePage;
